export default "__VITE_ASSET__D2GFHDHl__"